/**
 * Created by Ning Jiang on 2021-11-17.
 */

import {TombstoneRipReelView} from "../reels/TombstoneRipReelView";
import {Layers, TombstoneRipLayers} from "./TombstoneRipLayers";
import {TombstoneRip} from "../TombstoneRip";
import {TombstoneRipSound} from "../sound/TombstoneRipSound";

export class Reel5Frame extends PIXI.Container {

    private _bottomContainer:PIXI.Sprite;
    private _bottomGlow:PIXI.spine.Spine;
    private _bottomSmoke:PIXI.spine.Spine;
    private _topFire:PIXI.spine.Spine;
    private _reelFrame:PIXI.Sprite;
    private _wildPatch:PIXI.Sprite;
    private _frameSpine:PIXI.spine.Spine;

    constructor() {
        super();

        this._bottomContainer = new PIXI.Sprite();
        this.addChild(this._bottomContainer);

        this._reelFrame = new PIXI.Sprite();
        this._reelFrame.anchor.set(0.5);
        this._reelFrame.visible = false;
        this.addChild(this._reelFrame);

        this._wildPatch = new PIXI.Sprite();
        this._wildPatch.anchor.set(0.5);
        this._wildPatch.visible = false;
        this.addChild(this._wildPatch);

        this.position.set(628, TombstoneRipReelView.REEL_AREAS[4].y + TombstoneRipReelView.REEL_AREAS[4].height * 0.5);
        TombstoneRipLayers.getLayer(Layers.POP)?.addChild(this);
    }

    public startSuperFs(mode:string, patch:string = ""):void {
        this._reelFrame.texture = TombstoneRip.assetLoader.getTextures(`reel5_frame_${mode}`)[0]
        this._reelFrame.visible = true;
        if(patch.length > 0) {
            this._wildPatch.texture = TombstoneRip.assetLoader.getTextures(`M_Wild_${patch}`)[0];
            this._wildPatch.visible = true;
        } else {
            this._wildPatch.visible = false;
        }
        TombstoneRip.reels[4].setSuperSpinMode(true);
    }

    public endSuperFs():void {
        if(this._reelFrame.visible) {
            const symbol = TombstoneRip.reels[4].getSymbol(0);
            symbol.setWild(false);
        }
        this._reelFrame.visible = false;
        this._wildPatch.visible = false;
        TombstoneRip.reels[4].setSuperSpinMode(false);
        this.resetFire();
    }

    public playFire():void {
        if(!this._topFire) {
            this._topFire = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("reel5Burning"));
            this._topFire.autoUpdate = true;
        }
        this.addChild(this._topFire);
        this._topFire.visible = true;
        this._topFire.state.setAnimation(0, "burning", true);
        TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.REELS_ON_FIRE, volume : 1, repeat : 100});
    }

    public resetFire():void {
        if(this._topFire && this._topFire.visible) {
            this._topFire.state.clearTrack(0);
            this._topFire.skeleton.setToSetupPose();
            this._topFire.state.setEmptyAnimation(0, 0);
            this._topFire.visible = false;
            if(this._topFire.parent) {
                this._topFire.parent.removeChild(this._topFire);
            }
        }

        this.stopSuperSpin();
    }

    public startSuperSpin():void {
        TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.RESPIN_SPIN, volume : 1});

        if(!this._bottomGlow) {
            this._bottomGlow = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("reel5Glow"));
            this._bottomGlow.autoUpdate = true;
        }
        this._bottomContainer.addChild(this._bottomGlow);
        this._bottomGlow.visible = true;
        this._bottomGlow.state.setAnimation(0, "glow", true);

        if(!this._bottomSmoke) {
            this._bottomSmoke = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("nearWinSmoke"));
            this._bottomSmoke.autoUpdate = true;
        }
        this._bottomContainer.addChild(this._bottomSmoke);
        this._bottomSmoke.visible = true;
        this._bottomSmoke.state.setAnimation(0, "smoke", true);

        if(!this._frameSpine) {
            this._frameSpine = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("reel5Frame"));
            this._frameSpine.autoUpdate = true;
        }
        this.addChild(this._frameSpine);
        this._frameSpine.visible = true;
        this._frameSpine.state.setAnimation(0, "frame", true);
    }

    public stopSuperSpin():void {
        if(this._bottomGlow) {
            this._bottomGlow.state.clearTrack(0);
            this._bottomGlow.skeleton.setToSetupPose();
            this._bottomGlow.state.setEmptyAnimation(0, 0);
            this._bottomGlow.visible = false;
            if(this._bottomGlow.parent) {
                this._bottomGlow.parent.removeChild(this._bottomGlow);
            }
        }

        if(this._bottomSmoke) {
            this._bottomSmoke.state.clearTrack(0);
            this._bottomSmoke.skeleton.setToSetupPose();
            this._bottomSmoke.state.setEmptyAnimation(0, 0);
            this._bottomSmoke.visible = false;
            if(this._bottomSmoke.parent) {
                this._bottomSmoke.parent.removeChild(this._bottomSmoke);
            }
        }

        if(this._frameSpine) {
            this._frameSpine.state.clearTrack(0);
            this._frameSpine.skeleton.setToSetupPose();
            this._frameSpine.state.setEmptyAnimation(0, 0);
            this._frameSpine.visible = false;
            if(this._frameSpine.parent) {
                this._frameSpine.parent.removeChild(this._frameSpine);
            }
        }
    }
}